import * as React from 'react';

import { useZerofyNotificationBadges } from '@xingternal/crate-communication-use-zerofy-notification-badges';
import {
  useActiveItem,
  useFeatureSwitch,
  useNotifications,
  useNotificationsHandler,
} from '@xingternal/hub';

const notificationKeysMap: Record<string, string> = {
  contacts: 'contactRequests',
  content: 'news',
  events: 'events',
  groups: 'groupsWeb',
  home: 'activities',
  disco: 'insights',
  messages: 'unseenMessages',
  jobs: 'jobs',
  'me-hub': 'meHub',
  premium: 'premiumPerksNew',
  proBusiness: 'probusinessNotifications',
  supi: 'notificationCenterWebVisionType',
};

const getModifiedNotificationKeysMap = (
  originalNotificationsKeysMap: Record<string, string>,
  isFeatureEnabled: boolean
): Record<string, string> => {
  if (isFeatureEnabled) {
    return { ...originalNotificationsKeysMap, supi: 'ncWeb' };
  } else {
    return originalNotificationsKeysMap;
  }
};

const Zerofier: React.VFC = () => {
  const isFeatureEnabled = useFeatureSwitch('enable_nc_3_0', false);
  const activeItem = useActiveItem();
  const notifications = useNotifications();
  const { change: changeNotification } = useNotificationsHandler();

  const { markBadgesAsSeen } = useZerofyNotificationBadges();
  const currentNotificationBadge =
    activeItem &&
    getModifiedNotificationKeysMap(notificationKeysMap, isFeatureEnabled)[
      activeItem
    ];

  const hasNotifications =
    currentNotificationBadge &&
    Boolean(notifications[currentNotificationBadge]);

  React.useEffect(() => {
    if (hasNotifications) {
      changeNotification(currentNotificationBadge, 0);
      markBadgesAsSeen([currentNotificationBadge]);
    }
  }, [
    changeNotification,
    currentNotificationBadge,
    hasNotifications,
    markBadgesAsSeen,
  ]);

  return <></>;
};

export { Zerofier };
